import React from 'react';
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Icon,
    Tooltip,
    Typography,
} from '@material-ui/core';

const cardStyle = {
    marginBottom: '24px',
    boxShadow: '0 2px 10px 0 rgba(0,0,0,0.1)',
    borderRadius: '8px',
    overflow: 'visible',
};

const cardHeaderStyle = {
    paddingBottom: '8px',
    backgroundColor: '#f7f9fc',
};

const sectionTitleStyle = {
    fontSize: '16px',
    fontWeight: 600,
    color: '#0f2147',
};

const iconStyle = {
    marginRight: '8px',
    color: '#2196F3',
};

const tooltipIconStyle = {
    fontSize: '16px',
    marginLeft: '4px',
    color: '#6b778c',
    verticalAlign: 'middle',
    cursor: 'help',
};

export default function SectionCard({ icon, title, tooltip, action, fillHeight, children }) {
    const style = fillHeight
        ? { ...cardStyle, height: '100%', display: 'flex', flexDirection: 'column' }
        : cardStyle;

    return (
        <Card style={style}>
            <CardHeader
                title={
                    <Box display="flex" alignItems="center">
                        <Icon style={iconStyle}>{icon}</Icon>
                        <Typography style={sectionTitleStyle}>{title}</Typography>
                        {tooltip && (
                            <Tooltip title={tooltip}>
                                <Icon style={tooltipIconStyle}>help_outline</Icon>
                            </Tooltip>
                        )}
                    </Box>
                }
                action={action}
                style={cardHeaderStyle}
            />
            <CardContent>
                {children}
            </CardContent>
        </Card>
    );
}
